// src/views/funcionarios/FuncionarioModal.jsx
import React, { useState, useEffect } from "react";

const estadosBR = ["AC","AL","AP","AM","BA","CE","DF","ES","GO","MA","MT","MS","MG","PA","PB","PR","PE","PI","RJ","RN","RS","RO","RR","SC","SP","SE","TO"];
const fmtPhone = (v) => { const d = (v || "").replace(/\D/g, "").slice(0, 11); return d.length <= 10 ? d.replace(/^(\d{2})(\d{4})(\d{0,4})/, "($1) $2-$3").trim() : d.replace(/^(\d{2})(\d{5})(\d{0,4})/, "($1) $2-$3").trim(); };
const fmtCPF   = (v) => { const d = (v || "").replace(/\D/g, "").slice(0, 11); return d.replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d)/, "$1.$2").replace(/(\d{3})(\d{1,2})$/, "$1-$2"); };
const fmtCEP   = (v) => { const d = (v || "").replace(/\D/g, "").slice(0, 8); return d.replace(/^(\d{5})(\d)/, "$1-$2"); };
const sanDate  = (v) => { if (!v || v === "") return ""; if (typeof v === "string" && v.includes("T")) return v.split("T")[0]; return v; };
const emailValido = (v) => !v || /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(v);
const validaCPF = (v) => {
  const d = (v || "").replace(/\D/g, "");
  if (d.length !== 11 || /^(\d)\1+$/.test(d)) return false;
  let s = 0; for (let i = 0; i < 9; i++) s += parseInt(d[i], 10) * (10 - i);
  let r = (s * 10) % 11; if (r === 10 || r === 11) r = 0; if (r !== parseInt(d[9], 10)) return false;
  s = 0; for (let i = 0; i < 10; i++) s += parseInt(d[i], 10) * (11 - i);
  r = (s * 10) % 11; if (r === 10 || r === 11) r = 0; return r === parseInt(d[10], 10);
};

const EMPTY = {
  nmCompleto: "", cargo: "", dtAdmissao: "", dtDesligamento: "",
  telefone: "", celular: "", email: "", observacao: "",
  cpf: "", estCivil: "Solteiro", dtNascimento: "", sexo: "Masculino", rg: "",
  profissao: "", localTrabalho: "",
  nmConjuge: "", profConjuge: "", dtNascConjuge: "", cpfConjuge: "", rgConjuge: "",
  cep: "", cidade: "", estado: "SP", bairro: "", endereco: "", numero: "", complemento: "",
  inativo: false,
};

const EC_LABELS = { Solteiro: "Solteiro(a)", Casado: "Casado(a)", Divorciado: "Divorciado(a)", Viuvo: "Viúvo(a)", UniaoEstavel: "União Estável" };

export default function FuncionarioModal({ show, onClose, onSave, editData, saving = false, condominioNome = "", serverError = null, clearServerError }) {
  const isEdit = !!editData?.id;
  const [form, setForm]     = useState(EMPTY);
  const [errors, setErrors] = useState({});
  const [tab, setTab]       = useState("dados");
  const [cepLoading, setCepLoading] = useState(false);

  useEffect(() => {
    if (!show) return;
    const base = editData ? { ...EMPTY, ...editData, inativo: !!editData.inativo } : { ...EMPTY };
    ["dtAdmissao", "dtDesligamento", "dtNascimento", "dtNascConjuge"].forEach((f) => { base[f] = sanDate(base[f]); });
    setForm(base); setErrors({}); setTab("dados");
  }, [show, editData]);

  const set = (f, v) => {
    setForm((p) => ({ ...p, [f]: v }));
    setErrors((p) => ({ ...p, [f]: undefined }));
    if (clearServerError) clearServerError();
  };

  const buscarCEP = async (raw) => {
    const cep = (raw || "").replace(/\D/g, ""); if (cep.length !== 8) return;
    setCepLoading(true);
    try {
      const r = await fetch(`https://viacep.com.br/ws/${cep}/json/`);
      const d = await r.json();
      if (!d.erro) {
        setForm((p) => ({
          ...p,
          endereco: d.logradouro || p.endereco,
          bairro:   d.bairro || p.bairro,
          cidade:   d.localidade || p.cidade,
          estado:   d.uf || p.estado,
        }));
      }
    } catch { /* silencioso */ }
    setCepLoading(false);
  };

  const validate = () => {
    const e = {};
    if (!form.nmCompleto.trim()) e.nmCompleto = "Nome completo é obrigatório";
    if (form.cpf?.trim() && !validaCPF(form.cpf)) e.cpf = "CPF inválido";
    if (form.cpfConjuge?.trim() && !validaCPF(form.cpfConjuge)) e.cpfConjuge = "CPF do cônjuge inválido";
    if (form.email && !emailValido(form.email)) e.email = "E-mail inválido";
    if (form.dtAdmissao && form.dtDesligamento && form.dtDesligamento < form.dtAdmissao) {
      e.dtDesligamento = "Não pode ser anterior à admissão";
    }
    setErrors(e);
    if (Object.keys(e).length) {
      // Vai para a aba que contém o primeiro erro
      if (e.nmCompleto || e.cpf || e.email || e.dtDesligamento) setTab("dados");
      else if (e.cpfConjuge) setTab("trabalho");
      return false;
    }
    return true;
  };

  const handleSave = () => {
    if (validate()) onSave({ ...form, id: editData?.id });
  };

  if (!show) return null;
  const isCasado = form.estCivil === "Casado";

  const tabs = [
    { id: "dados",    label: "Dados Pessoais", icon: "bi-person-vcard" },
    { id: "trabalho", label: "Profissional",   icon: "bi-briefcase" },
    { id: "endereco", label: "Endereço",       icon: "bi-geo-alt" },
  ];

  return (
    <div className="modal fade show d-block" style={{ background: "rgba(0,0,0,.55)" }} tabIndex="-1">
      <div className="modal-dialog modal-xl modal-dialog-scrollable">
        <div className="modal-content">
          <div className="modal-header">
            <div className="d-flex align-items-center gap-3">
              <div style={{ width: 38, height: 38, background: "rgba(255,255,255,.15)", borderRadius: 8, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <i className="bi bi-person-badge" style={{ fontSize: 18, color: "#fff" }} />
              </div>
              <div>
                <h5 className="modal-title mb-0">{isEdit ? "Editar Funcionário" : "Novo Funcionário"}</h5>
                <small style={{ color: "rgba(255,255,255,.6)", fontSize: 12 }}>{condominioNome}</small>
              </div>
            </div>
            <button className="btn-close btn-close-white" onClick={onClose} />
          </div>

          <div style={{ background: "var(--primary)", padding: "0 24px" }}>
            <ul className="nav nav-tabs border-0" style={{ gap: 4 }}>
              {tabs.map((t) => (
                <li key={t.id} className="nav-item">
                  <button
                    className={`nav-link border-0 d-flex align-items-center gap-2 ${tab === t.id ? "active" : ""}`}
                    style={{
                      background: tab === t.id ? "#fff" : "transparent",
                      color: tab === t.id ? "var(--primary)" : "rgba(255,255,255,.7)",
                      borderRadius: "6px 6px 0 0",
                      fontFamily: "Poppins,sans-serif", fontSize: 13, fontWeight: 500, padding: "10px 18px",
                    }}
                    onClick={() => setTab(t.id)}
                  >
                    <i className={`bi ${t.icon}`} />{t.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="modal-body">
            {serverError && (
              <div className="alert alert-danger d-flex justify-content-between align-items-start" role="alert" style={{ fontSize: 13 }}>
                <div><i className="bi bi-exclamation-triangle-fill me-2" />{serverError}</div>
                {clearServerError && (
                  <button type="button" className="btn-close" onClick={clearServerError} style={{ fontSize: 10 }} />
                )}
              </div>
            )}

            {tab === "dados" && (
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-person-vcard" /> Identificação</div>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label className="form-label">Nome Completo <span className="required-mark">*</span></label>
                      <input
                        className={`form-control ${errors.nmCompleto ? "is-invalid" : ""}`}
                        value={form.nmCompleto}
                        onChange={(e) => set("nmCompleto", e.target.value)}
                        placeholder="Nome completo"
                      />
                      {errors.nmCompleto && <div className="invalid-feedback">{errors.nmCompleto}</div>}
                    </div>
                    <div className="col-md-4">
                      <label className="form-label">Cargo</label>
                      <input
                        className="form-control"
                        value={form.cargo}
                        onChange={(e) => set("cargo", e.target.value)}
                        placeholder="Ex: Porteiro, Zelador..."
                      />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">CPF</label>
                      <input
                        className={`form-control ${errors.cpf ? "is-invalid" : ""}`}
                        value={form.cpf}
                        onChange={(e) => set("cpf", fmtCPF(e.target.value))}
                        placeholder="000.000.000-00"
                      />
                      {errors.cpf && <div className="invalid-feedback">{errors.cpf}</div>}
                    </div>
                    <div className="col-md-3"><label className="form-label">RG</label><input className="form-control" value={form.rg} onChange={(e) => set("rg", e.target.value)} /></div>
                    <div className="col-md-3"><label className="form-label">Data de Nascimento</label><input type="date" className="form-control" value={form.dtNascimento} onChange={(e) => set("dtNascimento", e.target.value)} /></div>
                    <div className="col-md-3">
                      <label className="form-label">Sexo</label>
                      <select className="form-select" value={form.sexo} onChange={(e) => set("sexo", e.target.value)}>
                        <option value="Masculino">Masculino</option>
                        <option value="Feminino">Feminino</option>
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Estado Civil</label>
                      <select className="form-select" value={form.estCivil} onChange={(e) => set("estCivil", e.target.value)}>
                        {Object.entries(EC_LABELS).map(([v, l]) => <option key={v} value={v}>{l}</option>)}
                      </select>
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Dt. Admissão</label>
                      <input type="date" className="form-control" value={form.dtAdmissao} onChange={(e) => set("dtAdmissao", e.target.value)} />
                    </div>
                    <div className="col-md-3">
                      <label className="form-label">Dt. Desligamento</label>
                      <input
                        type="date"
                        className={`form-control ${errors.dtDesligamento ? "is-invalid" : ""}`}
                        value={form.dtDesligamento}
                        onChange={(e) => set("dtDesligamento", e.target.value)}
                        min={form.dtAdmissao || undefined}
                      />
                      {errors.dtDesligamento && <div className="invalid-feedback">{errors.dtDesligamento}</div>}
                    </div>
                    <div className="col-md-2 d-flex align-items-end pb-1">
                      <div className="form-check form-switch">
                        <input
                          className="form-check-input" type="checkbox" id="funcInativo"
                          checked={form.inativo} onChange={(e) => set("inativo", e.target.checked)}
                        />
                        <label className="form-check-label" htmlFor="funcInativo" style={{ fontSize: 13, fontWeight: 600, color: "var(--gray-600)" }}>
                          Inativo
                        </label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-telephone" /> Contato</div>
                  <div className="row g-3">
                    <div className="col-md-3"><label className="form-label">Telefone</label><input className="form-control" value={form.telefone} onChange={(e) => set("telefone", fmtPhone(e.target.value))} placeholder="(00) 0000-0000" /></div>
                    <div className="col-md-3"><label className="form-label">Celular</label><input className="form-control" value={form.celular} onChange={(e) => set("celular", fmtPhone(e.target.value))} placeholder="(00) 00000-0000" /></div>
                    <div className="col-md-4">
                      <label className="form-label">E-mail</label>
                      <input
                        className={`form-control ${errors.email ? "is-invalid" : ""}`}
                        type="email"
                        value={form.email}
                        onChange={(e) => set("email", e.target.value)}
                      />
                      {errors.email && <div className="invalid-feedback">{errors.email}</div>}
                    </div>
                    <div className="col-12"><label className="form-label">Observações</label><textarea className="form-control" rows={2} value={form.observacao} onChange={(e) => set("observacao", e.target.value)} /></div>
                  </div>
                </div>
              </>
            )}

            {tab === "trabalho" && (
              <>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-briefcase" /> Dados Profissionais</div>
                  <div className="row g-3">
                    <div className="col-md-4"><label className="form-label">Profissão</label><input className="form-control" value={form.profissao} onChange={(e) => set("profissao", e.target.value)} /></div>
                    <div className="col-md-5"><label className="form-label">Local de Trabalho</label><input className="form-control" value={form.localTrabalho} onChange={(e) => set("localTrabalho", e.target.value)} /></div>
                  </div>
                </div>
                <div className="form-section">
                  <div className="form-section-title"><i className="bi bi-people" /> Dados do Cônjuge</div>
                  {isCasado ? (
                    <div className="row g-3">
                      <div className="col-md-6"><label className="form-label">Nome do Cônjuge</label><input className="form-control" value={form.nmConjuge} onChange={(e) => set("nmConjuge", e.target.value)} /></div>
                      <div className="col-md-4"><label className="form-label">Profissão</label><input className="form-control" value={form.profConjuge} onChange={(e) => set("profConjuge", e.target.value)} /></div>
                      <div className="col-md-3">
                        <label className="form-label">CPF do Cônjuge</label>
                        <input
                          className={`form-control ${errors.cpfConjuge ? "is-invalid" : ""}`}
                          value={form.cpfConjuge}
                          onChange={(e) => set("cpfConjuge", fmtCPF(e.target.value))}
                          placeholder="000.000.000-00"
                        />
                        {errors.cpfConjuge && <div className="invalid-feedback">{errors.cpfConjuge}</div>}
                      </div>
                      <div className="col-md-3"><label className="form-label">RG do Cônjuge</label><input className="form-control" value={form.rgConjuge} onChange={(e) => set("rgConjuge", e.target.value)} /></div>
                      <div className="col-md-3"><label className="form-label">Dt. Nascimento</label><input type="date" className="form-control" value={form.dtNascConjuge} onChange={(e) => set("dtNascConjuge", e.target.value)} /></div>
                    </div>
                  ) : (
                    <div style={{ textAlign: "center", padding: "32px 0", color: "var(--gray-400)" }}>
                      <i className="bi bi-people" style={{ fontSize: 32, display: "block", marginBottom: 8 }} />
                      <p style={{ fontSize: 13 }}>Disponível apenas para estado civil <strong>Casado(a)</strong></p>
                    </div>
                  )}
                </div>
              </>
            )}

            {tab === "endereco" && (
              <div className="form-section">
                <div className="form-section-title"><i className="bi bi-geo-alt" /> Endereço Residencial</div>
                <div className="row g-3">
                  <div className="col-md-3">
                    <label className="form-label">CEP</label>
                    <div className="input-group">
                      <input
                        className="form-control"
                        value={form.cep}
                        onChange={(e) => set("cep", fmtCEP(e.target.value))}
                        onBlur={(e) => buscarCEP(e.target.value)}
                        placeholder="00000-000" maxLength={9}
                      />
                      <button className="btn btn-outline-secondary" type="button" onClick={() => buscarCEP(form.cep)} disabled={cepLoading}>
                        {cepLoading ? <span className="spinner-border spinner-border-sm" /> : <i className="bi bi-search" />}
                      </button>
                    </div>
                  </div>
                  <div className="col-md-5"><label className="form-label">Endereço</label><input className="form-control" value={form.endereco} onChange={(e) => set("endereco", e.target.value)} /></div>
                  <div className="col-md-2"><label className="form-label">Número</label><input className="form-control" value={form.numero} onChange={(e) => set("numero", e.target.value)} /></div>
                  <div className="col-md-2"><label className="form-label">Complemento</label><input className="form-control" value={form.complemento} onChange={(e) => set("complemento", e.target.value)} /></div>
                  <div className="col-md-4"><label className="form-label">Bairro</label><input className="form-control" value={form.bairro} onChange={(e) => set("bairro", e.target.value)} /></div>
                  <div className="col-md-4"><label className="form-label">Cidade</label><input className="form-control" value={form.cidade} onChange={(e) => set("cidade", e.target.value)} /></div>
                  <div className="col-md-2">
                    <label className="form-label">Estado</label>
                    <select className="form-select" value={form.estado} onChange={(e) => set("estado", e.target.value)}>
                      {estadosBR.map((uf) => <option key={uf}>{uf}</option>)}
                    </select>
                  </div>
                </div>
              </div>
            )}
          </div>

          <div className="modal-footer d-flex justify-content-between">
            <div style={{ fontSize: 12, color: "var(--gray-400)" }}>
              <i className="bi bi-asterisk me-1" style={{ color: "#ef4444", fontSize: 9 }} />Campos obrigatórios
            </div>
            <div className="d-flex gap-2">
              <button className="btn btn-outline-secondary" onClick={onClose}><i className="bi bi-x-circle" /> Cancelar</button>
              <button className="btn btn-primary" onClick={handleSave} disabled={saving}>
                {saving ? <><span className="spinner-border spinner-border-sm me-2" />Salvando...</> : <><i className="bi bi-check-circle" /> {isEdit ? "Salvar Alterações" : "Cadastrar"}</>}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
